<template>
    <div class="cargameRank-tabComponent raceRewards-wrappers">
        <div class="position-relative items-center top-headerBoxIn">
            <div class="backToApp" id="close" @click="viewClose('someStatus')">
                <div class="angle white-angle"></div>
            </div>
            <div class="text-center text-white agencyCentre-headerHD">Race Rewards</div>
        </div>
        <div class="position-relative justify-content-between listToggle">
            <img :src='rulesInfoIcon' @click="showRulesRewardPopup" class="rules-infoIcon" alt="" />
            <img :src='awwardsIcon' @click="showRewardPopup" class="awwards-infoIcon" alt="" />
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }"
                        @click="activateTab('thisweek')" data-toggle="tab" href="#thisweek" role="tab">Today</div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }"
                        @click="activateTab('lastweek')" data-toggle="tab" href="#lastweek" role="tab">Yesterday
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisweek">
                    <RankThisweekComponent />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastweek">
                    <RankLastweekComponent />
                </div>
            </div>
        </div>

        <div class="mode-area" v-show="isPopupOverlayVisible" @click="showRewardPopup"></div>
        <div
            :class="{ 'rewardPopupWrapper raceReward-popupWrap': true, 'transform-in': rewardsPopupVisible, 'transform-out': !rewardsPopupVisible }">
            <div class="rewardPopupInner scale-up-bottom">
                <img :src='popupClosed' class="closed" @click="showRewardPopup">
                <div class="rewards-bg">
                    <h4 class="text-center text-white mb-0 h4">Total Rewards</h4>
                    <div class="rewardPopupContBox">
                        <div class="reward-boxWrap">
                            <div class="d-flex justify-content-between align-itens-center carRaceDailyRewardBG">
                                <div class="carRace_rewardLeftBox">
                                    <div>Daily Reward</div>
                                    <div class="dailyReward_val d-flex align-items-center gap-2">
                                        <div>{{ dailyTotal }}</div>
                                        <img :src='diamondIcon' class="diamondIcon" alt="" />
                                    </div>
                                </div>
                                <div class="reward_multiDiamondImage">
                                    <img :src='multiDiamondImage' alt="" />
                                </div>
                            </div>
                            <!-- Top 3 (fixed cards as per your design) -->
                            <div class="d-flex justify-content-between mt-3 mb-2 topThree-rewardPopupContBox">
                                <div class="rewardCoin-box" v-if="topThreeRewards[1] !== '-'">
                                    <div class="m-auto reward_rankIcon"><img :src="reward_rank1" alt="" /></div>
                                    <div class="rewardCoin-ContBox">
                                        <div class="d-flex align-items-center gap-2 text-white">
                                            <div>{{ topThreeRewards[1] }}</div>
                                            <img :src="diamondIcon" class="diamondIcon" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="rewardCoin-box" v-if="topThreeRewards[2] !== '-'">
                                    <div class="m-auto reward_rankIcon"><img :src="reward_rank2" alt="" /></div>
                                    <div class="rewardCoin-ContBox">
                                        <div class="d-flex align-items-center gap-2 text-white">
                                            <div>{{ topThreeRewards[2] }}</div>
                                            <img :src="diamondIcon" class="diamondIcon" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="rewardCoin-box" v-if="topThreeRewards[3] !== '-'">
                                    <div class="m-auto reward_rankIcon"><img :src="reward_rank3" alt="" /></div>
                                    <div class="rewardCoin-ContBox">
                                        <div class="d-flex align-items-center gap-2 text-white">
                                            <div>{{ topThreeRewards[3] }}</div>
                                            <img :src="diamondIcon" class="diamondIcon" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Dynamic groups from rank 4 onward -->
                            <div class="d-flex flex-wrap justify-content-between">
                                <div v-for="(g, i) in displayRanges" :key="i"
                                    class="d-flex flex-wrap justify-content-center align-items-center text-white rankBox_2"
                                    :class="{ 'rankBox-full-width': g.start >= 6 }">
                                    <div class="">{{ rangeLabel(g) }} : &nbsp;</div>
                                    <div class="d-flex align-items-center gap-1 text-white">
                                        <div>{{ g.reward_coin }}</div>
                                        <img :src="diamondIcon" class="diamondIcon" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mode-area" v-show="isRulesPopupOverlayVisible" @click="showRulesRewardPopup"></div>
        <div
            :class="{ 'rewardPopupWrapper': true, 'transform-in': rulesRewardsPopupVisible, 'transform-out': !rulesRewardsPopupVisible }">
            <div class="rewardPopupInner scale-up-bottom">
                <img :src='popupClosed' class="closed" @click="showRulesRewardPopup">
                <div class="rewards-bg">
                    <h4 class="text-center text-white mb-0 h4">Rules</h4>
                    <div class="rewardPopupContBox">
                        <div class="text-white rules-rewardsPoints">
                            <ol>
                                <li>
                                    <div class="rules-pointsHD"><b>24 Hours Challenge</b></div>
                                    <div>The player with the most valid wins in 24 hours gets the top rewards.</div>
                                    <div>जो खिलाड़ी 24 घंटे में सबसे ज़्यादा वैध जीत करेगा, वही सबसे बड़े रिवॉर्ड पाएगा।
                                    </div>
                                </li>
                                <li>
                                    <div class="rules-pointsHD"><b>What Counts as a WIN?</b></div>
                                    <div>A win means your return must always be greater than your bet amount.</div>
                                    <div>जीत का मतलब है कि आपका रिटर्न हमेशा आपके बेट से ज़्यादा होना चाहिए।</div>
                                    <div>If your return is less than your bet (even after winning), it will not be
                                        counted as a win.</div>
                                    <div>अगर जीतने के बाद रिटर्न आपके बेट से कम निकला, तो वह जीत नहीं मानी जाएगी।</div>
                                    <div>Example: Betting on all 3 cars doesn’t guarantee a win, because dynamic odds
                                        may give you less return than your bet.</div>
                                    <div>उदाहरण: तीनों कारों पर बेट लगाने से जीत पक्की नहीं है, क्योंकि डायनमिक ऑड्स से
                                        रिटर्न बेट से कम भी हो सकता है।</div>
                                </li>
                                <li>
                                    <div class="rules-pointsHD"><b>Minimum Bet for Rewards</b></div>
                                    <div>To qualify for daily rewards, you must bet at least 300 diamonds (total) in a
                                        race.</div>
                                    <div>डेली रिवॉर्ड पाने के लिए कम से कम 300 डायमंड (कुल) का बेट लगाना ज़रूरी है।
                                    </div>
                                    <div>Example: Car A = 100 + Car B = 200 → Total = 300 ✅ Eligible</div>
                                    <div>उदाहरण: कार A = 100 + कार B = 200 → कुल = 300 ✅ योग्य</div>
                                    <div>Less than 300 total = ❌ Not eligible (even if you win).</div>
                                    <div>कुल बेट 300 से कम = ❌ योग्य नहीं (जीतने के बाद भी)।</div>
                                </li>
                                <li>
                                    <div class="rules-pointsHD"><b>Key Takeaway</b></div>
                                    <div>Win more, climb higher, and earn bigger rewards – but only valid wins count!
                                    </div>
                                    <div>जितनी ज़्यादा जीत, उतना ऊँचा रैंक और बड़ा रिवॉर्ड – लेकिन सिर्फ वैध जीत ही गिनी
                                        जाएगी!</div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import './CarGame.css'
import RankThisweekComponent from "./RankThisweekComponent.vue"
import RankLastweekComponent from "./RankLastweekComponent.vue"
import diamondIcon from '../../assets/images/diamond-icon.png'
import awwardsIcon from '../../assets/images/TG-awwards-icon.webp'
import rulesInfoIcon from '../../assets/images/rules-info.webp'
import popupClosed from '../../assets/images/popupClosed.svg';
import multiDiamondImage from '../../assets/images/diamonds-image.webp';
import reward_rank1 from '../../assets/images/reward_rank1.webp'
import reward_rank2 from '../../assets/images/reward_rank2.webp'
import reward_rank3 from '../../assets/images/reward_rank3.webp'

export default {
    name: 'RaceRewardsComponent',
    components: {
        RankThisweekComponent,
        RankLastweekComponent
    },
    data() {
        return {
            carRaceGameRewardData: [],
            carRaceGame_dailyTotalReward_Data: '',
            activeTab: 'thisweek',
            isLoadedThisweek: false,
            isLoadedLastweek: false,
            awwardsIcon,
            rulesInfoIcon,
            diamondIcon,
            multiDiamondImage,
            reward_rank1,
            reward_rank2,
            reward_rank3,

            popupClosed,
            rewardsPopupVisible: false,
            isPopupOverlayVisible: false,
            rulesRewardsPopupVisible: false,
            isRulesPopupOverlayVisible: false,

            hideZeroRewards: true,
            loading: false,
        }
    },
    computed: {
        // Normalize: dedupe by rank (keep latest updated_at), sort ascending
        normalizedRows() {
            const rows = this.carRaceGameRewardData || [];
            const map = new Map();
            for (const row of rows) {
                const prev = map.get(row.rank);
                if (!prev) {
                    map.set(row.rank, row);
                } else {
                    const newer =
                        new Date(row.updated_at) >= new Date(prev.updated_at) ? row : prev;
                    map.set(row.rank, newer);
                }
            }
            return [...map.values()].sort((a, b) => a.rank - b.rank);
        },

        // Group contiguous ranks with same reward
        rewardRanges() {
            const out = [];
            const rows = this.normalizedRows;
            if (!rows.length) return out;

            let start = rows[0].rank;
            let end = rows[0].rank;
            let reward = Number(rows[0].reward_coin);

            const flush = () => {
                if (this.hideZeroRewards && reward === 0) return;
                out.push({ start, end, reward_coin: reward });
            };

            for (let i = 1; i < rows.length; i++) {
                const r = rows[i];
                const sameReward = Number(r.reward_coin) === reward;
                const contiguous = r.rank === end + 1;

                if (contiguous && sameReward) {
                    end = r.rank;
                } else {
                    flush();
                    start = end = r.rank;
                    reward = Number(r.reward_coin);
                }
            }
            flush();

            return out;
        },

        // Only show ranges from rank 4 onward (since top 1–3 have custom cards)
        displayRanges() {
            return this.rewardRanges.filter((g) => g.end >= 4).map((g) => {
                // If a range overlaps 1–3, trim the start to 4 to avoid duplicating top cards
                return g.start < 4 ? { ...g, start: 4 } : g;
            });
        },

        // keep your existing daily total but fall back to API field if blank
        dailyTotal() {
            return this.carRaceGame_dailyTotalReward_Data || this.apiDailyTotalFromRaw || 0;
        },

        apiDailyTotalFromRaw() {
            // optional safety if you later store the whole API object
            return '';
        },

        // computed map for top 3 rewards (so template is simple & reactive)
        topThreeRewards() {
            // prepare default display values (show '-' when missing)
            const out = { 1: '-', 2: '-', 3: '-' };
            // use normalizedRows to pick the latest per rank
            for (const r of this.normalizedRows) {
                const rank = Number(r.rank);
                if (rank >= 1 && rank <= 3) {
                    // ensure reward_coin is shown as a number or fallback '-'
                    const val = (r.reward_coin === null || r.reward_coin === undefined || r.reward_coin === '') ? '-' : Number(r.reward_coin);
                    out[rank] = val;
                }
            }
            return out;
        },
    },
    mounted() {
        this.isLoadedThisweek = true;
        this.fetchCarRaceGameRewardData();
    },
    methods: {
        fetchCarRaceGameRewardData() {
            this.loading = true;
            axios.get('api/cargame/rank_weakly_api.php?type=1').then(response => {
                // defensive: ensure structure exists
                const data = response && response.data ? response.data : {};
                this.carRaceGameRewardData = data.dailyrewards || [];
                this.carRaceGame_dailyTotalReward_Data = data.dailytotalreward || '';

                // debug logs (remove in production)

                // console.log('dailytotalreward', this.carRaceGame_dailyTotalReward_Data)
                // console.log('normalizedRows after fetch:', this.normalizedRows.slice(0, 10));
                // console.log('top3 computed:', this.topThreeRewards);
            })
                .catch(error => {
                    console.error('Error fetching rewards:', error);
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        activateTab(tabId) {
            this.activeTab = tabId;
            if (tabId === 'thisweek' && !this.isLoadedThisweek) {
                this.isLoadedThisweek = true;
            }
            if (tabId === 'lastweek' && !this.isLoadedLastweek) {
                this.isLoadedLastweek = true;
            }
        },
        showRewardPopup() {
            this.rewardsPopupVisible = !this.rewardsPopupVisible;
            this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
        },
        showRulesRewardPopup() {
            this.rulesRewardsPopupVisible = !this.rulesRewardsPopupVisible;
            this.isRulesPopupOverlayVisible = !this.isRulesPopupOverlayVisible;
        },
        findRewardByRank(rank) {
            const row = this.normalizedRows.find((r) => Number(r.rank) === Number(rank));
            return row ? (row.reward_coin === '' || row.reward_coin === null ? '-' : row.reward_coin) : '-';
        },

        ordinal(n) {
            const s = ['th', 'st', 'nd', 'rd'],
                v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        },

        rangeLabel({ start, end }) {
            return start === end
                ? `Rank ${this.ordinal(start)}`
                : `Rank ${this.ordinal(start)} to ${this.ordinal(end)}`;
        },
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                Android.viewClose(status);
            }
        }
    },
}
</script>
